import React, { useState, useEffect, useRef } from 'react';

function SwaggerDocs() {
    var wrapperRef = useRef(null);

    // Compute the iframe src once on mount, seeding it with whatever
    // ?section= and ?endpoint= params are already in the parent URL so the
    // iframe can restore the right state on load / hard-refresh.
    var [iframeSrc] = useState(function() {
        var params       = new URLSearchParams(window.location.search);
        var section      = params.get('section');
        var endpoint     = params.get('endpoint');
        var iframeParams = new URLSearchParams();
        if (section)  iframeParams.set('section',  section);
        if (endpoint) iframeParams.set('endpoint', endpoint);
        var search = iframeParams.toString() ? '?' + iframeParams.toString() : '';
        return '/swagger-ui.html' + search;
    });

    useEffect(function() {
        // The iframe posts { type: 'swagger-section', section: <string|null>, endpoint: <string|null> }
        // whenever the open tag or endpoint changes.  Mirror both into the
        // parent URL so browser back/forward and copy-link work as expected.
        function handleMessage(event) {
            if (!event.data || event.data.type !== 'swagger-section') return;
            var section  = event.data.section;
            var endpoint = event.data.endpoint;
            var params   = new URLSearchParams();
            if (section)  params.set('section',  section);
            if (endpoint) params.set('endpoint', endpoint);
            var search = params.toString() ? '?' + params.toString() : '';
            window.history.replaceState(null, '', window.location.pathname + search);
        }

        window.addEventListener('message', handleMessage);
        return function() {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div ref={wrapperRef} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <iframe
                src={iframeSrc}
                title="API Docs"
                style={{ flex: 1, border: 'none', width: '100%', minHeight: '100vh' }}
            />
        </div>
    );
}

export default SwaggerDocs;
